import Vue from 'vue'
import Vuex from 'vuex'
import * as util from '../unit/network.js'
import { MessageBox } from 'element-ui';
import router from '../router'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		isLogin: false,
		nextToken: null,
		schoolData: {},
		admin_id: null,
		user_id: null,
		userInfo: {},

	},
	mutations: {
		setAdminId(state, provider) {
			state.admin_id = provider;
			localStorage.setItem('admin_id', provider);
		},
		setIslogin(state, provider) {
			state.isLogin = provider;
			localStorage.setItem('isLogin', provider);
		},
		setToken(state, provider) {
			state.nextToken = provider;
			localStorage.setItem('nextToken', provider);
		},
		setUserId(state, provider) {
			state.user_id = provider;
			localStorage.setItem('user_id', provider);
		},
		defaultimg(state, provider) {
			state.defaultimg = provider;
			localStorage.setItem('defaultimg', provider);
		},
		setUserInfo(state, provider) {
			state.userInfo = provider;
			localStorage.setItem('userInfo', JSON.stringify(provider));
		},
		setSchoolData(state, provider) {
			state.schoolData = provider;
			localStorage.setItem('schoolData', JSON.stringify(provider));
		},


	},
	actions: {
		getCompanyUserInfo({
			commit
		}) {
			util.post(
				"v2/school_job/getCompanyUserInfo", {
					user_id: localStorage.getItem('user_id'),
					admin_id: localStorage.getItem('admin_id'),
				},
				(res) => {
					console.log(res);
					if (res.code == 0) {
						if (res.data) {
							if (res.data.status === 0) {
								MessageBox.alert('抱歉，您的账号已被贵司超级管理员注销，请联系管理员开启账号权限！', '标题', {
									confirmButtonText: '确定',
									callback: () => {
										localStorage.removeItem('user_id')
										localStorage.removeItem('userInfo')
										localStorage.removeItem('schoolData')
										localStorage.removeItem('admin_id')
										localStorage.removeItem('nextToken')
										//缺少清空vuex储存的数据
										commit('setAdminId', '')
										commit('setUserInfo', '')
										commit('setSchoolData', '')
										commit('setUserId', '')
										commit('setToken', '')
										router.push({
											path: `/login`,
											// query: {
											//   id: 1,
											// },
										});
									}
								});
							} else {
								let ids = (res.data.user_id) % 26 || 0
								commit('defaultimg', res.data.avatar ||
									`https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
								)
								commit('setUserInfo', res.data)
							}
						} else {
							let admin_id = localStorage.getItem('admin_id')
							if(admin_id&admin_id!='null'){
								localStorage.removeItem('user_id')
								localStorage.removeItem('userInfo')
								localStorage.removeItem('schoolData')
								localStorage.removeItem('admin_id')
								localStorage.removeItem('nextToken')
								//缺少清空vuex储存的数据
								commit('setAdminId', '')
								commit('setUserInfo', '')
								commit('setSchoolData', '')
								commit('setUserId', '')
								commit('setToken', '')
								router.push({
									path: `/login`,
									// query: {
									//   id: 1,
									// },
								});
							}
							
						}

						// localStorage.setItem("schoolData", res.data);
						// this.$router.push({
						// 	path: "/main",
						// 	// query: {
						// 	//   id: 1,
						// 	// },
						// });
					}
				}
			);
		},
		getUserInfo({
			commit
		}) {
			util.post(
				"v2/school_job/getCompanyInfo", {
					admin_id: localStorage.getItem('admin_id')
				},
				(res) => {
					console.log(res);
					if (res.code == 200) {
						commit('setSchoolData', res.data)
						// localStorage.setItem("userInfo", res.data);
						// this.$router.push({
						// 	path: "/main",
						// 	// query: {
						// 	//   id: 1,
						// 	// },
						// });
					}else if(res.code==500){
						MessageBox.alert('抱歉，该企业已注销，请联系管理员！', '标题', {
							confirmButtonText: '确定',
							callback: () => {
								localStorage.removeItem('user_id')
								localStorage.removeItem('userInfo')
								localStorage.removeItem('schoolData')
								localStorage.removeItem('admin_id')
								localStorage.removeItem('nextToken')
								//缺少清空vuex储存的数据
								commit('setAdminId', '')
								commit('setUserInfo', '')
								commit('setSchoolData', '')
								commit('setUserId', '')
								commit('setToken', '')
								router.push({
									path: `/login`,
									// query: {
									//   id: 1,
									// },
								});
							}
						});
					}else{
						localStorage.removeItem('user_id')
						localStorage.removeItem('userInfo')
						localStorage.removeItem('schoolData')
						localStorage.removeItem('admin_id')
						localStorage.removeItem('nextToken')
						//缺少清空vuex储存的数据
						commit('setAdminId', '')
						commit('setUserInfo', '')
						commit('setSchoolData', '')
						commit('setUserId', '')
						commit('setToken', '')
						router.push({
							path: `/login`,
							// query: {
							//   id: 1,
							// },
						});
					}
				}
			);
		},
	},
	modules: {

	}
})